import axios from "./axios";
import { authen, server, user, other } from "./constants";
import api from "./api";
import store from "@/store";
import router from "@/router"

// ==========================
// =  User Authen Function  = 
// ==========================

/**
 * Login with email and password
 * @param  {{email: String, password: String}} value email and password
 * @return {{success: boolean, accessToken?: String, expires?: Number, userInfo?: object, storeInfo?: object}}
 */
const login = async (value) => {
    let { data } = await axios.post(authen.LOGIN_URL, value);
    // console.log(result.data);
    if (data && data.success) {
        // Store data to Local Storage
        if (data.refreshToken) localStorage.setItem(server.REFRESH_TOKEN, data.refreshToken);
        localStorage.setItem(server.ACCESS_TOKEN, data.accessToken);
        localStorage.setItem(server.TOKEN_EXPIRE, data.expires);
        localStorage.setItem(server.USER_INFO, JSON.stringify(data.userInfo));
        if (data.storeInfo)
            localStorage.setItem(server.STORE_INFO, JSON.stringify(data.storeInfo));
    }
    return data;
}

/**
 * Register
 * @param  {{email: String, password: String, firstname: String, lastname: String}} value
 * @return {{success: boolean}}
 */
const register = async (value) => {
    let result = await axios.post(authen.REGISTER_URL, value);
    // console.log(result.data);
    return result.data;
}

const updateLoginInfo = ({ userInfo, storeInfo }) => {
    if (userInfo) {
        let _userInfo = JSON.parse(localStorage.getItem(server.USER_INFO));
        userInfo.type = _userInfo.type;
        localStorage.setItem(server.USER_INFO, JSON.stringify(userInfo));
    }
    if (storeInfo)
        localStorage.setItem(server.STORE_INFO, JSON.stringify(storeInfo));
}

/**
 * Check if token is expires
 * @returns {Boolean}
 */
const isTokenExpire = () => {
    let expTimeStamp = JSON.parse(localStorage.getItem(server.TOKEN_EXPIRE));
    if (!expTimeStamp) return false;
    let expired = new Date().getTime() >= expTimeStamp;
    // if (expired) localStorage.removeItem(server.TOKEN_EXPIRE);
    return expired;
}

let _renewTokenAPI = {
    data: null,
    _loading: false,
    get loading() {
        return this._loading;
    },
    set loading(v) {
        this._loading = v;
        if (v == false) {
            while (this.Listener.length)
                (this.Listener.pop())(this.data);
        } else {
            this.data = null;
        }
    },
    Listener: [],
    addListener: function (func) {
        this.Listener.push(func);
    }
}

/**
 * Renew token using refreshToken
 * @return {boolean}
 */
const renewToken = async () => {
    console.log('renew tk');
    if (_renewTokenAPI.loading) {
        // loading, someone has alredy call this
        console.log('que')
        let data = await new Promise(r => _renewTokenAPI.addListener(r));
        return data && data.success;
    }
    let refreshToken = localStorage.getItem(server.REFRESH_TOKEN);
    if (!refreshToken) return false;

    _renewTokenAPI.loading = true;
    let { data } = await axios.post(authen.RENEWTOKEN_URL, { refreshToken });
    _renewTokenAPI.data = data;
    _renewTokenAPI.loading = false;
    if (store.getters['isLogged']) {
        if (data && data.success) {
            localStorage.setItem(server.ACCESS_TOKEN, data.accessToken);
            localStorage.setItem(server.TOKEN_EXPIRE, data.expires);
            if (data.refreshToken) localStorage.setItem(server.REFRESH_TOKEN, data.refreshToken);
            return true;
        } else {
            // renew fail then LOGOUT
            console.log('logout')
            store.dispatch("Logout");
            router.push("/login");
        }
    }
    return false;
}

let _startRenewTimer = false;
const startRenewAccessTokenTimer = async () => {
    console.log('call re-timer');
    if (_startRenewTimer) return false;
    _startRenewTimer = true;

    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    if (!accessToken) return false;
    let expTimeStamp = JSON.parse(localStorage.getItem(server.TOKEN_EXPIRE));
    let durationBeforeRenew = expTimeStamp - new Date() - 0.5 * 60 * 1000; // in ms
    console.log('waiting for', durationBeforeRenew / (60 * 1000));
    if (durationBeforeRenew > 0) await new Promise(r => setTimeout(r, durationBeforeRenew));
    console.log('req new atk');

    let { data } = await axios.post(authen.RENEWTOKEN_URL, { accessToken });
    if (data && data.success && store.getters['isLogged']) {
        localStorage.setItem(server.ACCESS_TOKEN, data.accessToken);
        localStorage.setItem(server.TOKEN_EXPIRE, data.expires);
        _startRenewTimer = false;
        startRenewAccessTokenTimer();
        return true;
    }
    return false;
}

/**
 * Restore all data when user refresh the page
 * @return {{userInfo: object, storeInfo: object, cartItems: object}}
 */
const restore = () => {
    if (isTokenExpire()) {
        console.log('expire')
        // api.makeAlert('Session timeout, Please login', 'secondary');
        renewToken().then((success) => {
            if (success) startRenewAccessTokenTimer();
            else {
                store.dispatch("Logout");
            }
        });
    } else if (store.getters['isLogged']) {
        startRenewAccessTokenTimer();
    }

    // console.log(localStorage.getItem(server.USER_INFO));
    let userInfo = JSON.parse(localStorage.getItem(server.USER_INFO));
    let storeInfo = JSON.parse(localStorage.getItem(server.STORE_INFO));
    let cartItems = JSON.parse(localStorage.getItem(server.CART_ITEM));
    return { userInfo, storeInfo, cartItems };
}

/**
 * Logout - Clear all user data
 */
const logout = async () => {
    let refreshToken = localStorage.getItem(server.REFRESH_TOKEN);
    const { data, status } = await axios.post(`${authen.LOGOUT_URL}`, { refreshToken });

    localStorage.removeItem(server.REFRESH_TOKEN);
    localStorage.removeItem(server.ACCESS_TOKEN);
    localStorage.removeItem(server.TOKEN_EXPIRE);

    localStorage.removeItem(server.USER_INFO);
    localStorage.removeItem(server.STORE_INFO);
}

/**
 * Request Email reset password
 */
const reqResetPwd = async (value) => {
    let result = await axios.post(authen.RESETPASSWORD_URL, value);
    return result.data;
}

/**
 * Update password
 */
 const updatePassword = async (value, params=null) => {
    let result = await axios.put(authen.RESETPASSWORD_URL, value, { params });
    return result.data;
}

/**
 * Send a payment information to server
 * @param {FormData} value Consist of 'bills, address, shippingMethod, totalPrice, paymentTimestamp, paymentImage'
 * @return {object}
 */
// const pay = async (value) => {
//     let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
//     const result = await axios.post(server.PAY_URL, value, {
//         headers: { 'Authorization': `be ${accessToken}` }
//     });
//     return result.data;
// }

// =====================================
// =  User / Account Manager Function  = 
// =====================================

const getProfile = async () => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.get(user.PROFILE_URL, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    if (data && data.success && store.getters['isLogged']) {
        localStorage.setItem(server.USER_INFO, JSON.stringify(data.userInfo));
        if (data.storeInfo) localStorage.setItem(server.STORE_INFO, JSON.stringify(data.storeInfo));
    }
    return data;
}

/**
 * Update Profile
 * @param {FormData} value 
 * @returns 
 */
const updateProfile = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.put(user.PROFILE_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

/**
 * Report Product
 * @param {String} _id 
 * @param {String} message 
 * @returns 
 */
const reportProduct = async (_id, message) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.post(user.REPORT_PRODUCT_URL, {_id, message}, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

/**
 * Report Store
 * @param {String} _id 
 * @param {String} message 
 * @returns 
 */
 const reportStore = async (_id, message) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    const { data } = await axios.post(user.REPORT_STORE_URL, {_id, message}, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const followStore = async (_id, isFollowed = true) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN), data;
    if (isFollowed)
        ({ data } = await axios.post(user.FOLLOW_STORE_URL, { _id }, {
            headers: { 'Authorization': `be ${accessToken}` }
        }));
    else
        ({ data } = await axios.delete(`${user.FOLLOW_STORE_URL}/${_id}`, {
            headers: { 'Authorization': `be ${accessToken}` }
        }));
    return data;
}

const getFollowedStore = async () => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    let { data } = await axios.get(user.FOLLOW_STORE_URL, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getConfig = (key) => {
    let config = localStorage.getItem(server.USER_CONFIG);
    config = JSON.parse(config) || {};
    return config[key];
}

const setConfig = (key, val) => {
    let config = localStorage.getItem(server.USER_CONFIG);
    config = JSON.parse(config) || {};
    config = { ...config, [key]: val }
    localStorage.setItem(server.USER_CONFIG, JSON.stringify(config));
}

const clickContactStore = async (params) => {
    console.log(other.CLICK_CONTACT_STORE_URL)
    let { data } = await axios.get(other.CLICK_CONTACT_STORE_URL, { params });
    return data;
}

export default {
    login,
    register,
    updateLoginInfo,
    isTokenExpire,
    restore,
    renewToken,
    logout,
    getProfile,
    updateProfile,
    reqResetPwd,
    updatePassword,
    followStore,
    getFollowedStore,
    reportProduct,
    reportStore,
    clickContactStore,

    getConfig,
    setConfig,
}